/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBadge7S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.305 2.281a1 1 0 0 1 1.39 0l1.874 1.813 2.581-.365a1 1 0 0 1 1.125.817l.45 2.568 2.303 1.221a1 1 0 0 1 .43 1.323L20.313 12l1.145 2.342a1 1 0 0 1-.43 1.323l-2.302 1.221-.45 2.568a1 1 0 0 1-1.126.817l-2.581-.365-1.874 1.813a1 1 0 0 1-1.39 0L9.43 19.906l-2.58.365a1 1 0 0 1-1.126-.817l-.45-2.568-2.303-1.222a1 1 0 0 1-.43-1.322L3.687 12 2.542 9.658a1 1 0 0 1 .43-1.323l2.303-1.221.45-2.568A1 1 0 0 1 6.85 3.73l2.581.365zm1.688 7.349-2.58 5.87h1.7l2.51-6.13V8.33h-5.15v2.42h.92l.43-1.12z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBadge7S as Badge7S };
